import { compose } from 'redux';

import { reduxForm } from 'redux-form';

import { withIntl } from 'HOC/withIntl';
import shouldSubmit from 'utilities/shouldSubmit';
import generateInitialLanguageValues from 'utilities/generateInitialLanguageValues';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';

import AddInfoCategoryForm from '../../components/InfoCategoryForm';

import { addInfoCategoryRequest } from '../../services/actions';
import {
    forms,
    requiredInfoCategoryFields,
    localizableInfoCategoryFields,
    defaultInfoCategoryValues,
} from '../../services/config';

const form = forms.addInfoCategoryForm;
const initialLangValues = generateInitialLanguageValues();

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(
        values,
        requiredInfoCategoryFields,
        intl.formatMessage({ id: 'error.required' }),
    );

const onSubmit = (data, dispatch, { intl }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableInfoCategoryFields, confirmMessage)) {
        dispatch(addInfoCategoryRequest(form, data));
    }
};

export default compose(
    withIntl,
    reduxForm({
        form,
        initialValues: {
            ...initialLangValues,
            ...defaultInfoCategoryValues,
        },
        validate,
        onSubmit,
    }),
)(AddInfoCategoryForm);
